export default "__VITE_ASSET__Dl6OfDE8__"